module.exports = __webpack_public_path__ + "static/images/megaphone.f439d59328bc83060813108ce42f4c3f.svg";